// store/useSnackbarStore.ts
import { create } from 'zustand';

interface SnackbarState {
  open: boolean;
  message: string;
  severity: 'success' | 'error' | 'warning' | 'info';
  showSnackbar: (message: string, severity: 'success' | 'error' | 'warning' | 'info') => void;
  closeSnackbar: () => void;
}

export const useSnackbarStore = create<SnackbarState>((set) => ({
  open: false,
  message: '',
  severity: 'success',
  showSnackbar: (message, severity) => set({ open: true, message, severity }),
  closeSnackbar: () => set({ open: false, message: '', severity: 'info' })
}));
